import axios from 'axios';

//获取海康摄像头
const cameraSearch = (data) => axios.get('/safe/ai/cameraSearch', data);

const getCameraPreviewURL = (data) => axios.get('/safe/ai/getCameraPreviewURL', data);

export default {

  cameraSearch,
  getCameraPreviewURL,

}


